var _path, _path2, _path3;

var _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgIcLineOfficialAccount(_ref, svgRef) {
  var title = _ref.title,
      titleId = _ref.titleId,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 16,
    height: 16,
    viewBox: "0 0 16 16",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M14.964 5.771v3.602c0 1.088-.406 2.028-1.07 2.859-1.285 1.603-3.008 2.587-4.825 3.47-.735.358-1.308.228-1.967-.083-1.172-.556-2.294-1.188-3.303-2.005-1.09-.883-1.975-1.926-2.32-3.324a4.992 4.992 0 0 1-.138-1.147c-.008-2.316-.008-4.632-.008-6.948 0-.738.164-.956.873-1.192A16.25 16.25 0 0 1 6.191.217C7.065.155 7.944.097 8.823.113c1.338.027 2.67.2 3.971.516a21.83 21.83 0 0 1 1.623.484c.383.126.548.386.548.795l-.001 3.863z",
    fill: "#00B900"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M7.515 6.468V4.312c0-.366-.093-.454-.453-.454H6.44c-.462 0-.543.075-.543.54v5.56c0 .477.09.568.568.568h2.837c.255 0 .51 0 .766-.01a.331.331 0 0 0 .343-.385v-.736c0-.398-.085-.484-.48-.485-.709 0-1.418-.008-2.127 0-.227 0-.298-.065-.294-.29.012-.715.005-1.434.005-2.152z",
    fill: "#00B900"
  })), _path3 || (_path3 = /*#__PURE__*/React.createElement("path", {
    d: "M7.516 6.468c0 .718.006 1.437 0 2.156 0 .227.072.294.293.29.71-.01 1.419 0 2.127 0 .396 0 .48.088.481.485 0 .245-.006.491 0 .737a.331.331 0 0 1-.354.382c-.255.011-.51.01-.766.01H6.46c-.472 0-.567-.093-.567-.567V4.4c0-.466.08-.54.542-.54h.624c.357 0 .447.09.454.453.004.717.003 1.436.003 2.154z",
    fill: "#fff"
  })));
}

var ForwardRef = /*#__PURE__*/React.forwardRef(SvgIcLineOfficialAccount);
export default __webpack_public_path__ + "static/media/ic-line-official-account.00672a79c49b8f7c2b8bbdb5ed2885dc.svg";
export { ForwardRef as ReactComponent };